// filepath: src/store/services/apiClient.js
import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE_URL || "https://api.star69.co";

const apiClient = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// NOTE: this instance did not carry the player's Authorization header (only the
// shared `axios` singleton did, via authSession.js's setSession()). Endpoints that
// now require a user/admin token would 401 for every call made through apiClient.
apiClient.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("accessToken") || localStorage.getItem("authToken");
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;
